<template>
    <div class="detail-platform-account">
        <div class="content">
            <div class="data-title">
                <div class="title-name">查看/编辑平台账号</div>
            </div>
            <!-- 查看 编辑的表单 -->
            <platform-account-form ref="platformAccountForm" :isDetail="true" @onHistory="onHistory" ></platform-account-form>
            <div class="footer" :class="[isCollapsed ? 'footer-collapsed' : '']">
                <template>
                    <el-button type="info" plain @click="onBack">返回</el-button>
                    <el-button v-if="permission.delete" type="danger" @click="onDelete" :loading="btnDelete">删除</el-button>
                    <el-button v-if="permission.cancel" type="danger" @click="onCancel" :loading="btnCancel">注销账号</el-button>
                    <el-button v-if="permission.revoke" type="info" plain @click="onRevoke" :loading="btnRevoke">撤销</el-button>
                    <el-button v-if="permission.transfer" type="primary" @click="onTransfer" :loading="btnTransfer">转移</el-button>
                    <el-button v-if="permission.edit" type="primary" @click="onSave" :loading="btnSave">保存</el-button>
                </template>
            </div>
        </div>
        <org-picker title="转移" :multiple="false" ref="orgPicker" @ok="selected" />
        <pop-report ref="popReport" :reportList="reportList" />
        <pop-cancel ref="popCancel" title="是否确认注销该平台账号？" @setCancel="setCancel" />
        <pop-revoke ref="popRevoke" title="是否确认撤销该平台账号？" @setRevoke="setRevoke" />
        <pop-delete ref="popDelete" title="是否确认删除？" @setDelete="setDelete" />
        <pop-history ref="popHistory" title="历史记录" />
    </div>
</template>
<script>
import popApprove from "@/pages/assetManagement/common/popApprove";
import popHistory from "@/pages/assetManagement/common/popHistory";
import platformAccountMixins from "@/pages/assetManagement/common/mixins/platformAccount";
import platformAccountForm from "@/pages/assetManagement/common/platformAccountForm.vue";
export default {
    name: 'addAccount',
    mixins: [platformAccountMixins],
    components: { popHistory, popApprove ,platformAccountForm},

    data() {
        return {
            permission:{},
            btnDelete:false,
            btnRevoke:false,
            btnCancel:false,
            btnTransfer:false,
            btnSave:false,
            btnApprove:false,
            btnShow:false,
            selectIds:[]
        }
    },
     activated() {
        this.fetchData()
    },
    created() {
        this.selectIds[0] = this.$route.query.id 
    },
    computed: {
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    methods: {
        
        onBack() {
            if (this.$route.query.back) {
                let backMenuIndex = localStorage.getItem('backMenuIndex')
                if (backMenuIndex) {
                   localStorage.removeItem('backMenuIndex')
                   localStorage.setItem('selectedMenuIndex',backMenuIndex); 
                }
            }
            this.$router.go(-1);
        },
        onDelete() {
            this.$refs.popDelete.show()
        },
        onCancel() {
            this.$refs.popCancel.show()
        },
        onRevoke() {
            this.$refs.popRevoke.show()
        },
        onTransfer(){
            this.$refs.orgPicker.show([],'user','transferUser')
        },
        onApprove(){
            this.$refs.popApprove.show()
        },
        onSave() {
            this.btnSave = true
            this.$refs.platformAccountForm.save()
        },
        // 历史记录
        onHistory() {
            this.$refs.popHistory.show('platformAccount')
        },
        fetchData() {
            this.$refs.platformAccountForm.reset()
        },
    },
}
</script>

<style lang="scss" scoped >
.content {
    width: 100%;
    min-height: calc(100vh - 118px);
    margin-top: 16px;
    padding: 0 16px;
    box-sizing: border-box;
    margin-bottom: 35px;
    background-color: #FFFFFF;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    flex: 1;
    
}
.data-title {
    width: 100%;
    height: 32px;
    margin-top: 20px;
    position: relative;
    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 9px;
        width: 2px;
        height: 16px;
        background: #00B498;
        border-radius: 0px 0px 0px 0px;
    }
    .title-name {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 18px;
        color: #2F3030;
        margin-left: 6px;
        line-height: 32px;
    }

}
.text {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #2F3030;
    margin-top: 32px;
    margin-bottom: 30px;
}



/* 底部按钮 */
.footer {
    height: 84px;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 200px;
    right: 0;
    bottom: 0;
    border-top: 1px solid #EDF2F2;
    box-sizing: border-box;
    transition: left 0.3s ease-in-out;
    z-index: 2;

    .el-button {
        min-width: 88px;
        padding: 12px 20px 10px;
    }

    .el-button+.el-button {
        margin-left: 16px;
    }
}

.footer-collapsed {
    left: 80px;
}
</style>